module.exports = __webpack_public_path__ + "static/media/GitHub_Logo.cefc2023.png";